<app-breadcrumb [breadcrumb]="breadcrumb"></app-breadcrumb>

<div
	class="row"
	*ngIf="loading">
	<div class="col text-center">
		<app-loader [material]="false"></app-loader>
	</div>
</div>

<div
	class="row"
	*ngIf="!loading">
	<div class="col-sm-12">
		<app-card
			[hidHeader]="true"
			cardClass="tab-card">

			<nav
				ngbNav
				[navsetlink]="nav"
				#nav="ngbNav"
				class="nav-tabs">
				<ng-container ngbNavItem="dati">
					<a
						routerLink="."
						fragment="dati"
						ngbNavLink>
						Dati
					</a>
					<ng-template ngbNavContent>
						<p [innerHTML]="objective.description"></p>
						<table
							class="table"
							*ngIf="objective">
							<tbody>
								<tr *ngIf="objective.id">
									<td>{{ 'labels.id' | translate }}</td>
									<td>{{ objective.id }}</td>
								</tr>
								<tr *ngIf="objective.name">
									<td>{{ 'labels.name' | translate }}</td>
									<td>{{ objective.name }}</td>
								</tr>
								<tr *ngIf="project.name">
									<td>{{'labels.project' | translate }}</td>
									<td>{{ project.name }}</td>
								</tr>

								<tr *ngIf="objective.dayofwork">
									<td>{{ 'labels.dayofwork' | translate }}</td>
									<td>{{ objective.dayofwork }}</td>
								</tr>

								<tr>
									<td>{{'labels.startdate' | translate }}</td>
									<td>
										{{ objective.startdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>
								<tr>
									<td>{{'labels.stopdate' | translate }}</td>
									<td>
										{{ objective.stopdate | date:'dd/MM/yyyy'}}
									</td>
								</tr>

								<div class="row mt-1">
									<div class="col">
										<button
											routerLink="/project/{{project.id}}/objective/edit/{{objective.id}}"
											class="btn btn-primary">
											{{'labels.edit' | translate | titlecase}}
										</button>
									</div>
								</div>
							</tbody>
						</table>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="attivita">
					<a
						routerLink="."
						fragment="attivita"
						ngbNavLink>
						Attività
					</a>
					<ng-template ngbNavContent>
						<app-activity-list [objectiveid]="objective.id"></app-activity-list>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="sezioniaggiuntive">
					<a
						routerLink="."
						fragment="sezioniaggiuntive"
						ngbNavLink>
						Sezioni aggiuntive
					</a>
					<ng-template ngbNavContent>
						<app-additional-sections
							*ngIf="project"
							[eid]="objective.id"
							[tenderid]="project.tenderid"
							entity="objective"></app-additional-sections>
					</ng-template>
				</ng-container>
				<ng-container ngbNavItem="documenti">
					<a
						routerLink="."
						fragment="documenti"
						ngbNavLink>
						Documenti
					</a>
					<ng-template ngbNavContent>
						<app-attachments
							[extradata]="{'company' : project?.companyid}"
							[card]="false"
							mediapath="download"
							[library]="true"
							entity="objective"
							[bootstrap]="true"
							[canvalidate]="true"
							[eid]="objective.id">
						</app-attachments>
					</ng-template>
				</ng-container>
			</nav>

			<div
				[ngbNavOutlet]="nav"
				class="mt-2"></div>

		</app-card>
	</div>
</div>
